// ⚠️ 자동 생성 파일 — 직접 수정 금지. 정본은 dentcluster-agent/shared/material-alias.js
//    수정 절차: 정본 수정 → node scripts/sync-shared.js (release-all.sh가 불일치 시 빌드 중단)
// [공통 정본] 재료 별칭 정규화 — 파서·양식별 표기 차이를 흡수해 같은 재료는 같은 토큰으로.
// 중복 키 v2(치과|환자|치식|작업월|재료 시그니처, 대표 확정 2026-08-05)의 재료 축이 이 함수로 결정된다.
//
// ★ 이 파일이 정본(shared/). 사본:
//   - 에이전트: electron/shared/material-alias.js (statement-collector 재료 시그니처)
//   - 웹: src/utils/shared/material-alias.js (CreateTransactionStatement 수집분 중복 제거)
//   수정 후 반드시 `node scripts/sync-shared.js` 실행 (release-all.sh가 불일치 시 중단).
//
// 통일 내력(2026-08-06, 기존 두 사본의 합집합):
//   - 에이전트 normMaterialToken: 비재료 토큰 필터(정상치·Model Material·Configuration_*), zirkon(독일어)
//   - 웹 normMat2: 템프/temp→pmma, 골드→gold, niti·코발트→metal, 피엠엠에이→pmma
//   에이전트 쪽 토큰이 바뀌는 입력(템프·골드·코발트 등)은 dedupId(v2)가 달라질 수 있으나,
//   legacyKey(치과|환자|치식) 형제 문서 탐색이 기존 문서에 병합한다 — statement-collector 참조.
// NFC 통일(#22): 앞단 normalize('NFC') — 맥 유래 NFD 한글(지르코니아 등)이 정규식에 안 걸리던 문제 해소.

function normMaterialToken(m) {
    const s = String(m == null ? '' : m).normalize('NFC').replace(/\s+/g, '').toLowerCase();
    if (!s) return '';
    // 비재료 토큰(비작업치·모형재·설정값) → '' (재료 없음 취급)
    if (/^(healthy|정상치|undefined|_null_)/.test(s) || /^configuration_/.test(s) || /modelmaterial/.test(s)) return '';
    if (/(zircon|zirkon|지르|^zr)/.test(s)) return 'zirconia';
    if (/(pmma|피엠엠에이|템프|temp)/.test(s)) return 'pmma';
    if (/(e[-.]?max|이맥스|리튬|lithium|disilicate)/.test(s)) return 'emax';
    if (/(titan|티타늄|^ti$)/.test(s)) return 'ti';
    if (/(metal|메탈|합금|niti|코발트)/.test(s)) return 'metal';
    if (/(gold|골드)/.test(s)) return 'gold';
    if (/(wax|왁스)/.test(s)) return 'wax';
    return s.replace(/[^a-z0-9가-힣]/g, '');   // 미지 재료는 표기 정규화만 (서로 다른 실재 재료는 갈라져야 함)
}

/** 재료 집합 부분집합 판정(⊆ 어느 방향이든) — 같은 케이스 병합 규칙 (대표 확정 2026-08-05).
 *  실사례: exocad(크라운=zirconia) ↔ 3Shape(어버트 포함=ti+zirconia)는 같은 건.
 *  빈 집합(재료 미기록)은 항상 부분집합 → 병합 허용. 서로소·부분 겹침은 별건.
 *  인자는 Set 또는 배열 모두 허용. */
function isMaterialSubset(a, b) {
    const A = a instanceof Set ? a : new Set(a || []);
    const B = b instanceof Set ? b : new Set(b || []);
    const [small, big] = A.size <= B.size ? [A, B] : [B, A];
    return [...small].every(t => big.has(t));
}

export { normMaterialToken, isMaterialSubset };